import type { SurveyOverlap } from 'app/common/api/requests/food/surveys/check_overlap/post'

const fieldTitles: Record<string, string> = {
  title: 'Наименование',
  starts_on: 'Дата начала',
  ends_on: 'Дата окончания',
  city_ids: 'Населённые пункты',
  district_ids: 'Районы',
  school_ids: 'Заведения',
  school_type: 'Тип заведения',
}

export const formatSurveyOverlaps = (overlaps: Array<SurveyOverlap>) =>
  overlaps
    .map(({ survey_title, period }) => `${survey_title} (${period})`)
    .join('\n')

export const getSurveyErrorMessage = (
  error: Error & {
    response?: {
      status?: number
      data?: {
        message?: string
        error_code?: string
        details?: Record<string, Array<string>>
        food_survey?: Record<string, Array<string>>
        overlaps?: Array<SurveyOverlap>
      }
    }
  },
  fallback: string,
) => {
  const data = error.response?.data
  if (data?.message === 'no schools match the selected filters') {
    return 'По выбранным фильтрам не найдено ни одного заведения. Измените параметры опроса.'
  }
  if (data?.message === 'invalid dates') {
    return 'Некорректный период опроса. Проверьте даты начала и окончания.'
  }
  if (data?.overlaps?.length) {
    return `Обнаружено пересечение периодов опроса:\n${formatSurveyOverlaps(data.overlaps)}`
  }
  if (data?.error_code === 'validation_failed') {
    const details = data.details || data.food_survey || {}
    const messages = Object.entries(details).flatMap(([field, errors]) =>
      errors.map((message) => `${fieldTitles[field] || field}: ${message}`),
    )
    if (messages.length) return messages.join('; ')
  }
  return data?.message || fallback
}
